import React, {forwardRef} from 'react';
import PropTypes from 'prop-types'
import BoxError from '../../Atoms/BoxError';
import { testAttributes, boxProps } from './Constants';
import './ComplianceBanner.scss';

const ComplianceBanner = forwardRef( ({ 
    message = boxProps.DEFAULT_MESSAGE, 
    closeAlert = () => 
    {}
}, ref) => (
    <div id="compliance-banner-container" data-testid={testAttributes.COMPLIANCE_BANNER_CONTAINER} ref={ref}>
        <BoxError
            type={boxProps.BOX_TYPE}
            closeAlert={closeAlert}
            msg={message}
            showIcon={false}
        />
    </div>
));

ComplianceBanner.propTypes = {
    /** 
     * Message set to BoxError type=info component. 
     * 
     * Renders message component if compliance cookie does not exist.
     * 
     * Sets a compliance cookie for 1 year if message is closed.
    */
    message: PropTypes.string,
    /* function to close the alert */
    closeAlert: PropTypes.func,
    /** flag to determine if the global nav is present */ 
    isGlobalNav: PropTypes.bool
}

export default ComplianceBanner;
